import { useActionMutation, type UseMutationProps } from '@ztechapps/common.hook'
import type { Blog, TranscribeBlogVideosArgs } from '@ztechapps/common.contract'
import { transcribeBlogVideosMutation } from '../graphql/transcribeBlogVideos'

/**
 * Hook to initiate video transcription for a blog post.
 * Extracts video URLs from the blog content and queues them for transcription.
 *
 * @example
 * ```tsx
 * const [transcribe, { loading, error }] = useTranscribeBlogVideos()
 *
 * const handleTranscribe = async () => {
 *   const blog = await transcribe({ blogId: 'blog-123' })
 *   const jobId = blog?.transcribingMetadata?.jobId
 *   const videoCount = blog?.transcribingMetadata?.videoCount ?? 0
 * }
 * ```
 */
export const useTranscribeBlogVideos = ({ query, ...props } = {} as UseMutationProps) => {
  query = query ?? transcribeBlogVideosMutation

  return useActionMutation<Blog, TranscribeBlogVideosArgs>({
    query,
    ...props,
  })
}
